﻿'use strict';

angular.module('ntmApp').factory('RoomSchedulesDragAndDropActions', ['DraggingObject', 'ForecastService', 'FlashService', 'ConfirmationService', 'Constants', 'RescheduleActivityLeeWayValidator', 'WatchDndTargetsService',
    function (DraggingObject, ForecastService, FlashService, ConfirmationService, Constants, RescheduleActivityLeeWayValidator, WatchDndTargetsService) {

        function RoomSchedulesDragAndDropActions(roomSchedules) {

            var self = this;
            var RoomSchedules = roomSchedules;

            var onStartDraggingEvent;
            var onDraggedEvent;
            var onOtherActivityDraggedEvent;

            self.dndTarget = [];

            self.unAssignStaffFromRoomSchedulingBlockDraggingPattern = 'UN_ASSIGN_STAFF';
            self.assignStaffDraggingPattern = 'ASSIGN_STAFF';
            self.rescheduleActivityDraggingPattern = 'RESCHEDULE_ACTIVITY';

            self.UnAssignStaffDraggingObject = new DraggingObject();
            self.AssignStaffDraggingObject = new DraggingObject();
            self.RescheduleActivityDraggingObject = new DraggingObject();

            self.onStartDragging = function (event) {
                onStartDraggingEvent = event;
            };

            self.onDragged = function (event) {
                onDraggedEvent = event;
            };

            self.onOtherActivityDragged = function (event) {
                onOtherActivityDraggedEvent = event;
            };

            self.startUnAssignStaff = function (activity) {

                self.UnAssignStaffDraggingObject.setDraggingObject(activity);

                if (onStartDraggingEvent) {
                    onStartDraggingEvent();
                }

            };

            self.unAssignStaffFromActivity = function (activity) {

                var request = {
                    scheduleIds: [activity.scheduleId]
                };

                var loading = FlashService.Loading();
                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from {1} for {2} on {3}."
                      .format(activity.assignee, activity.activity, activity.roomNumber, moment(activity.dateSchedule).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onDraggedEvent) {
                            onDraggedEvent(activity.roomNumber);
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };

            self.unAssignStaffFromActivityGroup = function (staff) {
                var loading = FlashService.Loading();

                var request = { scheduleIds: staff.schedules };

                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from {1} {2} on {3}."
                      .format(staff.personName, staff.roomNumber, staff.locate, moment(staff.date).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onDraggedEvent) {
                            onDraggedEvent(staff.roomNumber);
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };

            self.unAssignStaffFromRoom = function (roomTotalAssigment, grid) {

                var activitiesToUnAssign = getActivitiesByPersonId(grid, roomTotalAssigment.personId);

                var request = {
                    scheduleIds: activitiesToUnAssign.map(function (activity) {
                        return activity.scheduleId;
                    })
                };

                var loading = FlashService.Loading();
                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from {1}’s activities on {2}."
                      .format(roomTotalAssigment.personName.trim(), grid.roomNumber, moment(grid.summary.date).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onDraggedEvent) {
                            onDraggedEvent(grid.roomNumber);
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };


            self.unAssignStaffFromOtherActivity = function (activity) {

                var request = {
                    scheduleIds: [activity.scheduleId]
                };

                var loading = FlashService.Loading();
                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from '{1}' in {2} on {3}."
                            .format(activity.assignee, activity.activity,RoomSchedules.selectedForecastScope.value, moment(activity.dateSchedule).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onOtherActivityDraggedEvent) {
                            onOtherActivityDraggedEvent();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };

            self.unAssignStaffFromOtherGroup = function (staff, group) {
                var schedulesIds = group.items && group.items.length > 0 ? group.items.map(function (activity) {
                    return activity.scheduleId;
                }) : [];

                var request = {
                    scheduleIds: schedulesIds
                };

                var loading = FlashService.Loading();
                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from {1}'s {2} activities on {3}."
                          .format(staff.personName,RoomSchedules.selectedForecastScope.value, group.otherActivityMode.toLowerCase(), moment(staff.date).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onOtherActivityDraggedEvent) {
                            onOtherActivityDraggedEvent();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };

            self.unAssignStaffFromOtherBlock = function (roomTotalAssigment, grid) {

                var activitiesToUnAssign = getActivitiesByPersonId(grid, roomTotalAssigment.personId);

                    var request = {
                        scheduleIds: activitiesToUnAssign.map(function (activity) { return activity.scheduleId; })
                };

                var loading = FlashService.Loading();
                ForecastService.UnAssignedStaffByScheduleId(request).then(function (result) {

                    if (result.success) {

                        var resultMessage = "{0} successfully un-assigned from {1} activities in {2} on {3}."
                          .format(roomTotalAssigment.personName.trim(), grid.summary.blockHeader.otherActivityMode.toLowerCase(),RoomSchedules.selectedForecastScope.value, moment(grid.summary.date).format("MM/DD/YYYY"));

                        FlashService.Success(resultMessage);

                        if (onOtherActivityDraggedEvent) {
                            onOtherActivityDraggedEvent();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            };

            self.endUnAssignStaff = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.UnAssignStaffDraggingObject.releaseDraggingObject();
                }
                self.dndTarget = [];
            };

            function getActivitiesByPersonId(grid, personId) {

                var activities = [];

                grid.groups.forEach(function (group) {
                    group.items.forEach(function (item) {

                        if (item.assigneeId === personId) {
                            activities.push(item);
                        }
                    });
                });

                return activities;
            }

            //Assign staff to activities 

            self.startAssignStaff = function (staff) {
                self.AssignStaffDraggingObject.setDraggingObject(staff);

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.RoomActivities) {
                    startAssignRoomStaff(staff);
                }

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.OtherActivities) {
                    startAssignOtherStaff(staff);
                }

                if (onStartDraggingEvent) {
                    onStartDraggingEvent();
                }
            };

            self.assignStaff = function (staff) {

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.RoomActivities) {
                    assignRoomStaff(staff);
                }

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.OtherActivities) {
                    assignOtherStaff(staff);
                }
            };

            self.endAssignStaff = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.AssignStaffDraggingObject.releaseDraggingObject();
                }

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.RoomActivities) {
                    RoomSchedules.defaultDragAndDropTargetsForBlockRoomHeaders();
                }

                if (RoomSchedules.selectedActivityType === Constants.ForecastActivityTypes.OtherActivities) {
                    RoomSchedules.defaultDragAndDropTargetsForBlockOtherActivityHeaders();
                }
            };

            function assignRoomStaff(staff) {
                var dow = findDateToggleTarget();

                if (dow) {
                    assignToRoomDow(staff, dow);
                    return;
                }

                var locateGroup = findLocateGroupTarget();

                if (locateGroup) {
                    assignToLocateGroup(staff, locateGroup);
                    return;
                }

                var activityTargetObject = findActivityTarget();

                if (activityTargetObject) {
                    assignToActivity(staff, activityTargetObject.activity, activityTargetObject.group);
                    return;
                }
            }

            function assignOtherStaff(staff) {
                var dow = findOtherActivityDateToggleTarget();

                if (dow) {
                    assignToOtherDow(staff, dow);
                    return;
                }

                var locateGroup = findOtherLocateGroupTarget();

                if (locateGroup) {
                    assignToOtherLocateGroup(staff, locateGroup);
                    return;
                }

                var activityTargetObject = findOtherActivityTarget();

                if (activityTargetObject) {
                    assignToOtherActivity(staff, activityTargetObject.activity, activityTargetObject.group);
                    return;
                }
            }

            function startAssignRoomStaff(staff) {

                RoomSchedules.roomBlockHeaders.forEach(function (block) {
                    block.dowActivityToggles.forEach(function (dow) {

                        if (isStaffAssignable(staff, dow)) {
                            dow.dndType = [self.assignStaffDraggingPattern];
                        } else {
                            dow.dndType = ['NONE'];
                        }

                        if (block.DOWActivitiesGrids) {
                            block.DOWActivitiesGrids.forEach(function (grid) {

                                if (grid.groups) {
                                    grid.groups.forEach(function (group) {

                                        if (isStaffAssignableToActivitiesGroup(staff, group)) {
                                            group.dndType = [self.assignStaffDraggingPattern];
                                        } else {
                                            group.dndType = ['NONE'];
                                        }

                                        group.items.forEach(function (activity) {

                                            if (isStaffAssignableToActivitiy(staff, activity)) {
                                                activity.dndType = [self.assignStaffDraggingPattern];
                                            } else {
                                                activity.dndType = ['NONE'];
                                            }
                                        });
                                    });
                                }

                            });
                        }
                    });
                });
            }

            function startAssignOtherStaff(staff) {
                if (RoomSchedules.otherActivitiesHeaders && RoomSchedules.otherActivitiesHeaders.area) {
                    RoomSchedules.otherActivitiesHeaders.area.dowActivityToggles.forEach(function (dow) {
                        if (isStaffAssignable(staff, dow)) {
                            dow.dndType = [self.assignStaffDraggingPattern];
                        } else {
                            dow.dndType = ['NONE'];
                        }
                    });

                    if (RoomSchedules.otherActivitiesHeaders.area.currentGrid) {
                        RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups.forEach(function (group) {
                            if (isStaffAssignableToActivitiesGroup(staff, group)) {
                                group.dndType = [self.assignStaffDraggingPattern];
                            } else {
                                group.dndType = ['NONE'];
                            }

                            group.items.forEach(function (activity) {

                                if (isStaffAssignableToActivitiy(staff, activity)) {
                                    activity.dndType = [self.assignStaffDraggingPattern];
                                } else {
                                    activity.dndType = ['NONE'];
                                }
                            });
                        });
                    }
                }

                if (RoomSchedules.otherActivitiesHeaders && RoomSchedules.otherActivitiesHeaders.facility) {
                    RoomSchedules.otherActivitiesHeaders.facility.dowActivityToggles.forEach(function (dow) {
                        if (isStaffAssignable(staff, dow)) {
                            dow.dndType = [self.assignStaffDraggingPattern];
                        } else {
                            dow.dndType = ['NONE'];
                        }
                    });

                    if (RoomSchedules.otherActivitiesHeaders.facility.currentGrid) {
                        RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups.forEach(function (group) {
                            if (isStaffAssignableToActivitiesGroup(staff, group)) {
                                group.dndType = [self.assignStaffDraggingPattern];
                            } else {
                                group.dndType = ['NONE'];
                            }

                            group.items.forEach(function (activity) {

                                if (isStaffAssignableToActivitiy(staff, activity)) {
                                    activity.dndType = [self.assignStaffDraggingPattern];
                                } else {
                                    activity.dndType = ['NONE'];
                                }
                            });
                        });
                    }
                }

            }

            function assignToRoomDow(staff, dow, isStaffSkillsCheck) {

                var request = {
                    scenarioBreadcrumb: RoomSchedules.getScenarioId(),
                    facilityCode: dow.blockHeader.facilityCode,
                    date: dow.date,
                    roomNumber: dow.blockHeader.roomNumber,
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    isExistingAssignments: RoomSchedules.UnderAllocatedStaff.replaceAssignments
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonIntoRoomAssignmentDOW(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {
                            FlashService.Success(result.data.message);

                            if (onDraggedEvent) {
                                onDraggedEvent(dow.blockHeader.roomNumber);
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToRoomDow(staff, dow, true);
                            };

                            ConfirmationService.YesNoConfirmation(getSkillErrorMessage(staff, result.data.bulletList), null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function assignToOtherDow(staff, dow, isStaffSkillsCheck) {

                var request = {
                    scenarioId: RoomSchedules.getScenarioId(),
                    date: dow.date,
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    forecastScopeCode: RoomSchedules.selectedForecastScope.id,
                    forecastScopeName: RoomSchedules.selectedForecastScope.value,
                    forecastScopeMode: RoomSchedules.forecastMode,
                    forecastScopeView: RoomSchedules.forecastView,
                    otherActivityMode: dow.mode,
                    isExistingAssignments: RoomSchedules.UnderAllocatedStaff.replaceAssignments,
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonIntoOtherAssignmentDOW(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {
                            FlashService.Success(result.data.message);

                            if (onOtherActivityDraggedEvent) {
                                onOtherActivityDraggedEvent();
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToOtherDow(staff, dow, true);
                            };

                            ConfirmationService.YesNoConfirmation(getSkillErrorMessage(staff, result.data.bulletList), null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function assignToLocateGroup(staff, locateGroup, isStaffSkillsCheck) {
                var request = {
                    scenarioBreadcrumb: RoomSchedules.getScenarioId(),
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    isExistingAssignments: RoomSchedules.UnderAllocatedStaff.replaceAssignments,
                    scheduleIds: locateGroup.items.filter(function (activity) {
                        return isStaffAssignableToActivitiy(staff, activity);
                    }).map(function (activity) {
                        return { scheduleId: activity.scheduleId, activityId: activity.activityId, activity: activity.activity, assigneeId: activity.assigneeId, speciesCode: activity.speciesId, speciesName: activity.speciesName };
                    })
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonIntoRoomAssignmentLocate(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {

                            var resultMessage="";

                            if(RoomSchedules.UnderAllocatedStaff.replaceAssignments){
                                resultMessage="{0} successfully assigned to the activities under {1} for room {2} on {3} (existing assignments replaced)."
                                    .format(staff.personName, locateGroup.key, locateGroup.roomNumber, moment(locateGroup.date).format("MM/DD/YYYY"));
                            }else{
                                resultMessage="{0} successfully assigned to the  un-assigned activities under {1} for room {2} on {3}."
                                .format(staff.personName, locateGroup.key, locateGroup.roomNumber, moment(locateGroup.date).format("MM/DD/YYYY"));
                            }

                            FlashService.Success(resultMessage);

                            if (onDraggedEvent) {
                                onDraggedEvent(locateGroup.roomNumber);
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToLocateGroup(staff, locateGroup, true);
                            };

                            ConfirmationService.YesNoConfirmation(getSkillErrorMessage(staff, result.data.bulletList), null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function assignToOtherLocateGroup(staff, locateGroup, isStaffSkillsCheck) {

                var schedulesIds = locateGroup.items && locateGroup.items.length > 0 ? locateGroup.items.map(function (activity) {
                    return { scheduleId: activity.scheduleId, activityId: activity.activityId, activity: activity.activity, assigneeId: activity.assigneeId };
                }) : [];

                var request = {
                    scenarioId: RoomSchedules.getScenarioId(),
                    scheduleIds:schedulesIds,
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    forecastScopeCode: RoomSchedules.selectedForecastScope.id,
                    forecastScopeName: RoomSchedules.selectedForecastScope.value,
                    forecastScopeMode: RoomSchedules.forecastMode,
                    isExistingAssignments: RoomSchedules.UnderAllocatedStaff.replaceAssignments,
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonIntoOtherAssignmentLocate(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {

                            var resultMessage="";

                            if(RoomSchedules.UnderAllocatedStaff.replaceAssignments){
                                resultMessage="{0} successfully assigned to the activities {1} activities on {2} (existing assignments replaced)."
                                    .format(staff.personName, locateGroup.key + " " + locateGroup.mode.toLowerCase(), moment(locateGroup.date).format("MM/DD/YYYY"));
                            }else{
                                resultMessage="{0} successfully assigned to the un-assigned {1} on {2}."
                                .format(staff.personName, locateGroup.key +" "+  locateGroup.mode.toLowerCase(), moment(locateGroup.date).format("MM/DD/YYYY"));
                            }
                            FlashService.Success(resultMessage);

                            if (onOtherActivityDraggedEvent) {
                                onOtherActivityDraggedEvent();
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToOtherLocateGroup(staff, locateGroup, true);
                            };

                            ConfirmationService.YesNoConfirmation(getSkillErrorMessage(staff, result.data.bulletList), null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function assignToActivity(staff, activity, locateGroup, isStaffSkillsCheck) {

                var request = {
                    scenarioBreadcrumb: RoomSchedules.getScenarioId(),
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    scheduleId: activity.scheduleId,
                    activityId: activity.activityId,
                    activityName: activity.activity,
                    speciesCode: activity.speciesId,
                    speciesName: activity.speciesName
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonToRoomActivity(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {

                            var resultMessage="{0} successfully assigned to {1}  under {2} for room {3} on {4}."
                             .format(staff.personName, activity.activity, locateGroup.key, locateGroup.roomNumber, moment(locateGroup.date).format("MM/DD/YYYY"));

                            FlashService.Success(resultMessage);

                            if (onDraggedEvent) {
                                onDraggedEvent(locateGroup.roomNumber);
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToActivity(staff, activity, locateGroup, true);
                            };


                            var skillErrorMessage = "Warning: {0} is not qualified to perform {1}".format(staff.personName, activity.activity);

                            if (activity.speciesName !== null && activity.speciesName !== undefined) {
                                skillErrorMessage += " for {0}".format(activity.speciesName);
                            }

                            skillErrorMessage += ". <br /><br/> Assign to {0} anyway? ".format(staff.personName);

                            ConfirmationService.YesNoConfirmation(skillErrorMessage, null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function assignToOtherActivity(staff, activity, locateGroup, isStaffSkillsCheck) {

                var request = {
                    date: locateGroup.date,
                    personId: staff.personId,
                    personName: staff.personName,
                    isStaffSkillsCheck: isStaffSkillsCheck,
                    scheduleId: activity.scheduleId,
                    activityId: activity.activityId,
                    activityName: activity.activity,
                    speciesCode: activity.speciesId,
                    speciesName: activity.speciesName,
                    forecastScopeCode: RoomSchedules.selectedForecastScope.id,
                    forecastScopeName: RoomSchedules.selectedForecastScope.value
                };

                var loading = FlashService.Loading();
                ForecastService.AssignPersonToOtherActivity(request).then(function (result) {

                    if (result.success) {

                        if (result.data.type === 'Success') {

                            var resultMessage = "{0} successfully assigned to {1}  in {2} on {3}."
                            .format(staff.personName, activity.activity, RoomSchedules.selectedForecastScope.value, moment(locateGroup.date).format("MM/DD/YYYY"));

                            FlashService.Success(resultMessage);

                            if (onOtherActivityDraggedEvent) {
                                onOtherActivityDraggedEvent();
                            }
                        }

                        if (result.data.type === 'SkillError') {

                            var performAction = function () {
                                assignToOtherActivity(staff, activity, locateGroup, true);
                            };

                            var skillErrorMessage = "Warning: {0} is not qualified to perform {1}".format(staff.personName,activity.activity);

                            if (activity.speciesName !== null && activity.speciesName !== undefined) {
                                skillErrorMessage += " for {0}".format(activity.speciesName);
                            }

                            skillErrorMessage += ". <br /><br/> Assign to {0} anyway? ".format(staff.personName);

                            ConfirmationService.YesNoConfirmation(skillErrorMessage, null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }
                    }
                }).finally(function () {
                    loading.dismiss();
                });
            }

            function isStaffAssignable(staff, dow) {
                return (RoomSchedules.UnderAllocatedStaff.replaceAssignments || dow.allActivityCount > dow.assignedActivityCount) &&
                        isStaffPresentAtDate(staff, dow.date);
            }

            function isStaffAssignableToActivitiesGroup(staff, group) {

                if (!isStaffPresentAtDate(staff, group.date)) {
                    return false;
                }

                if (RoomSchedules.UnderAllocatedStaff.replaceAssignments) {
                    return true;
                }

                return group.items && group.items.some(function (item) {
                    return !item.assigneeId;
                });
            }

            function isStaffAssignableToActivitiy(staff, activity) {
                return (!activity.assigneeId || activity.assigneeId !== staff.personId) &&
                       isStaffPresentAtDate(staff, activity.dateSchedule);
            }

            function isStaffPresentAtDate(staff, date) {

                var staffDay = staff.staffDays.firstOrDefault(function (staffDayItem) {
                    return moment(staffDayItem.date).isSame(moment(date), 'day');
                });

                return staffDay && Constants.StaffAttendTypes.isStaffPresent(staffDay.attendString);
            }

            function findDateToggleTarget() {

                for (var i = 0; i < RoomSchedules.roomBlockHeaders.length; i++) {

                    var targetDow = RoomSchedules.roomBlockHeaders[i].dowActivityToggles.firstOrDefault(function (dow) {
                        return dow.dndTarget && dow.dndTarget.length > 0;
                    });

                    if (targetDow) {
                        return targetDow;
                    }
                }

                return null;
            }

            function findOtherActivityDateToggleTarget() {
                var targetDow = null;

                if (RoomSchedules.otherActivitiesHeaders.area) {
                    targetDow = RoomSchedules.otherActivitiesHeaders.area.dowActivityToggles.firstOrDefault(function (dow) {
                        return dow.dndTarget && dow.dndTarget.length > 0;
                    });

                    if (targetDow) {
                        targetDow.mode = 'Area';
                        return targetDow;
                    }

                }

                if (RoomSchedules.otherActivitiesHeaders.facility) {
                    targetDow = RoomSchedules.otherActivitiesHeaders.facility.dowActivityToggles.firstOrDefault(function (dow) {
                        return dow.dndTarget && dow.dndTarget.length > 0;
                    });

                    if (targetDow) {
                        targetDow.mode = 'Facility';
                        return targetDow;
                    }
                }

                return targetDow;
            }

            function findLocateGroupTarget() {

                for (var i = 0; i < RoomSchedules.roomBlockHeaders.length; i++) {

                    var block = RoomSchedules.roomBlockHeaders[i];

                    if (block.DOWActivitiesGrids) {

                        for (var k = 0; k < block.DOWActivitiesGrids.length; k++) {

                            var grid = block.DOWActivitiesGrids[k];

                            if (grid.groups) {

                                for (var groupIndex = 0; groupIndex < grid.groups.length; groupIndex++) {

                                    if (grid.groups[groupIndex].dndTarget && grid.groups[groupIndex].dndTarget.length > 0) {
                                        return grid.groups[groupIndex];
                                    }
                                }
                            }
                        }
                    }
                }

                return null;
            }

            function findOtherLocateGroupTarget() {
                var group = null;

                if (RoomSchedules.otherActivitiesHeaders.area && RoomSchedules.otherActivitiesHeaders.area.currentGrid) {
                    for (var i = 0; i < RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups.length; i++) {

                        if (RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups[i].dndTarget && RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups[i].dndTarget.length > 0) {
                            group = RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups[i];
                            group.mode = "Area";
                            return group;
                        }
                    }
                }

                if (RoomSchedules.otherActivitiesHeaders.facility && RoomSchedules.otherActivitiesHeaders.facility.currentGrid) {
                    for (var it = 0; it < RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups.length; it++) {

                        if (RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups[it].dndTarget && RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups[it].dndTarget.length > 0) {
                            group = RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups[it];
                            group.mode = "Faicility";

                            return group;
                        }
                    }
                }

                return group;
            }

            function findActivityTarget() {

                for (var i = 0; i < RoomSchedules.roomBlockHeaders.length; i++) {

                    var block = RoomSchedules.roomBlockHeaders[i];

                    if (block.DOWActivitiesGrids) {

                        for (var k = 0; k < block.DOWActivitiesGrids.length; k++) {

                            var grid = block.DOWActivitiesGrids[k];

                            if (grid.groups) {

                                for (var groupIndex = 0; groupIndex < grid.groups.length; groupIndex++) {

                                    var group = grid.groups[groupIndex];

                                    if (group.items) {

                                        for (var activityIndex = 0; activityIndex < group.items.length; activityIndex++) {
                                            if (group.items[activityIndex].dndTarget && group.items[activityIndex].dndTarget.length > 0) {
                                                return {
                                                    activity: group.items[activityIndex],
                                                    group: group
                                                };
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                return null;
            }

            function findOtherActivityTarget() {

                if (RoomSchedules.otherActivitiesHeaders.area && RoomSchedules.otherActivitiesHeaders.area.currentGrid) {
                    for (var i = 0; i < RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups.length; i++) {
                        var areaGroup = RoomSchedules.otherActivitiesHeaders.area.currentGrid.groups[i];

                        for (var activityIndex = 0; activityIndex < areaGroup.items.length; activityIndex++) {
                            if (areaGroup.items[activityIndex].dndTarget && areaGroup.items[activityIndex].dndTarget.length > 0) {
                                return {
                                    activity: areaGroup.items[activityIndex],
                                    group: areaGroup
                                };
                            }
                        }
                    }
                }

                if (RoomSchedules.otherActivitiesHeaders.facility && RoomSchedules.otherActivitiesHeaders.facility.currentGrid) {
                    for (var it = 0; it < RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups.length; it++) {
                        var group = RoomSchedules.otherActivitiesHeaders.facility.currentGrid.groups[it];

                        for (var index = 0; index < group.items.length; index++) {
                            if (group.items[index].dndTarget && group.items[index].dndTarget.length > 0) {
                                return {
                                    activity: group.items[index],
                                    group: group
                                };
                            }
                        }
                    }
                }

                return null;
            }

            function getSkillErrorMessage(staff, skills) {

                var skillsList = "<ul>";

                skills.forEach(function (skill) {
                    var item = '<li>{0}</li>'.format(skill);
                    skillsList += item;
                });

                skillsList += '</ul>';

                return "Warning: {0} is not qualified to perform the following: <br /><br /> {1} Assign anyway?"
                                 .format(staff.personName, skillsList);
            }

            //Reschedule Activity

            self.startRescheduleActivity = function (activity, blockHeader) {
                self.RescheduleActivityDraggingObject.setDraggingObject(activity);
                blockHeader.dowActivityToggles.forEach(function (dow) {

                    if (!moment(activity.dateSchedule).isSame(moment(dow.date), 'day')) {
                        dow.dndType = [self.rescheduleActivityDraggingPattern];
                    } else {
                        dow.dndType = ['NONE'];
                    }

                });


            };

            self.rescheduleActivity = function (activity, activityParentGroup, blockHeader) {

                var target = blockHeader.dowActivityToggles.firstOrDefault(function (dow) {
                    return dow.dndTarget && dow.dndTarget.length > 0;
                });

                if (target) {

                    var action = function () {
                        var request = {
                            scenarioId: RoomSchedules.getScenarioId(),
                            scheduleId: activity.scheduleId,
                            activityAssigneeId: activity.assigneeId,
                            sourcePer: activity.per,
                            targetDate: target.date
                        };

                        rescheduleActivityAction(activity, activityParentGroup, request);
                    };

                    var leeWayValidator = new RescheduleActivityLeeWayValidator(activity, target.date);
                    var confirmationsConfiguration = {
                        resultAction: action,
                        confirmations: [
                            { validator: leeWayValidator, data: { title: 'Alert', no: 'Never mind' } }
                        ]
                    };

                    ConfirmationService.ValidationsChain(confirmationsConfiguration);
                }
            };

            self.rescheduleOtherActivity = function (activity, activityParentGroup, blockHeader) {

                var target = blockHeader.dowActivityToggles.firstOrDefault(function (dow) {
                    return dow.dndTarget && dow.dndTarget.length > 0;
                });

                if (target) {

                    var action = function() {
                        var request = {
                            scenarioId: RoomSchedules.getScenarioId(),
                            scheduleId: activity.scheduleId,
                            activityAssigneeId: activity.assigneeId,
                            sourcePer: activity.per,
                            targetDate: target.date,
                            activityName: activity.activity
                        };
                        rescheduleOtherActivityAction(activity, activityParentGroup, request);
                    };

                    var leeWayValidator = new RescheduleActivityLeeWayValidator(activity, target.date);
                    var confirmationsConfiguration = {
                        resultAction: action,
                        confirmations: [
                            { validator: leeWayValidator, data: { title: 'Alert', no: 'Never mind' } }
                        ]
                    };

                    ConfirmationService.ValidationsChain(confirmationsConfiguration);
                }
            };

            self.endRescheduleActivity = function (blockHeader) {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.RescheduleActivityDraggingObject.releaseDraggingObject();
                }
                blockHeader.dowActivityToggles.forEach(function (dow) {
                    dow.dndTarget = [];
                    dow.dndType = [];
                });
            };

            function rescheduleActivityAction(activity, activityParentGroup, request) {

                var loading = FlashService.Loading();

                ForecastService.RescheduleActivity(request).then(function (result) {

                    if (result.success) {

                        loading.dismiss();

                        if (result.data.type === 'Success') {
                            FlashService.Success("{0}'s '{1}' successfully moved to {2}".format(activityParentGroup.key, activity.activity, moment(request.targetDate).format('MM/DD/YYYY')));

                            if (onDraggedEvent) {
                                onDraggedEvent(activity.roomNumber);
                            }

                        } else {

                            var performAction = function () {

                                var nextRequest = angular.copy(request);
                                nextRequest.skipStaffAttendStateValidation = true;
                                nextRequest.unAssignActivityFromStaff = true;

                                rescheduleActivityAction(activity, activityParentGroup, nextRequest);
                            };

                            var messagePattern = "Warning: Assignee {0} {1} on {2}. They will be <b>automatically removed</b> from the activity.<br /><br />Move activity to {2} anyway?";
                            var message = messagePattern.format(activity.assignee, Constants.StaffAttendTypes.isPTO(result.data.attendState) ? 'is off on PTO' : 'is not working', moment(request.targetDate).format('MM/DD/YYYY'));

                            ConfirmationService.YesNoConfirmation(message, null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }

                    } else {
                        loading.dismiss();
                    }
                });
            }

            function rescheduleOtherActivityAction(activity, activityParentGroup, request) {

                var loading = FlashService.Loading();

                ForecastService.RescheduleOtherActivity(request).then(function (result) {

                    if (result.success) {

                        loading.dismiss();

                        if (result.data.type === 'Success') {
                            FlashService.Success("'{0}' successfully moved to {1}".format(activity.activity, moment(request.targetDate).format('MM/DD/YYYY')));

                            if (onOtherActivityDraggedEvent) {
                                onOtherActivityDraggedEvent();
                            }

                        } else {

                            var performAction = function () {

                                var nextRequest = angular.copy(request);
                                nextRequest.skipStaffAttendStateValidation = true;
                                nextRequest.unAssignActivityFromStaff = true;

                                rescheduleOtherActivityAction(activity, activityParentGroup, nextRequest);
                            };

                            var messagePattern = "Warning: Assignee {0} {1} on {2}. They will be <b>automatically removed</b> from the activity.<br /><br />Move activity to {2} anyway?";
                            var message = messagePattern.format(activity.assignee, Constants.StaffAttendTypes.isPTO(result.data.attendState) ? 'is off on PTO' : 'is not working', moment(request.targetDate).format('MM/DD/YYYY'));

                            ConfirmationService.YesNoConfirmation(message, null, { title: 'Alert', no: 'Never mind' })
                                               .Yes(performAction)
                                               .Ask();
                        }

                    } else {
                        loading.dismiss();
                    }
                });
            }
        }

        return (RoomSchedulesDragAndDropActions);
    }]);